import { NotificationResponseDtoEventEnum } from '@app/api';

export const isCollapsableByEvent = (event: NotificationResponseDtoEventEnum) => {
  switch (event) {
    case NotificationResponseDtoEventEnum.GreetingsPatient:
    case NotificationResponseDtoEventEnum.GreetingsTherapist:
      return true;
    default:
      return false;
  }
};
